import { defineComponent } from '@vue/composition-api'
import cn from './locales/cn.json'
import en from './locales/en.json'

export const BExportNotice = defineComponent({
  name: 'BExportNotice',
  i18n: {
    messages: {
      cn,
      en,
    },
  },
  props: {
    limit: {
      required: true,
      type: Number,
    },
  },
  setup(props) {
    return {}
  },
  render() {
    return (
      <div class="flex flex-col gap-y-5 text-sm text-black-default">
        <div>
          <div class="font-semibold">{this.$t('BExportNotice.notice')}</div>
          <div>{this.$t('BExportNotice.noticeContent', { limit: this.limit })}</div>
        </div>
        <div>
          <div class="font-semibold">{this.$t('BExportNotice.note')}</div>
          <div>{this.$t('BExportNotice.noteContent')}</div>
        </div>
        <div>{this.$t('BExportNotice.confirmProceed')}</div>
      </div>
    )
  },
})
